<script>
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    totalFailed: {
      type: Number,
      required: false,
    },
    totalSuccess: {
      type: Number,
      required: false,
    },
    totalData: {
      type: Number,
      required: false,
    },
    errorFile: {
      type: String,
      required: false,
    },
    fileName: {
      type: String,
      required: false,
    },
    fileType: {
      type: String,
      required: false,
    },
    docType: {
      String,
    },
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),
    illustrationPathSuccess() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/success.svg`)
      }
      return require(`@/assets/images/illustration/saas/success.svg`)
    },
    illustrationPathFailed() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/failed.svg`)
      }
      return require(`@/assets/images/illustration/saas/failed.svg`)
    },
  },
  methods: {
    toDownload() {
      let temp = 'data:' + this.fileType + ';base64,' + encodeURIComponent(this.errorFile)
      let download = document.createElement('a')
      download.href = temp
      download.download = 'data_gagal_' + this.fileName
      document.body.appendChild(download)
      download.click()
      document.body.removeChild(download)
    },
  },
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="mc-upload">
        <div class="mc-upload-result mc-upload-result--success" v-if="totalFailed === 0">
          <figure>
            <img :src="illustrationPathSuccess" alt />
          </figure>
          <h4 class="mc-upload-result__label">
            {{ $t('license.object.uploadData') }} {{ docType }} {{ $t('license.object.success') }}
          </h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('license.object.totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('license.object.dataSuccess') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('license.object.dataFailed') }}
            </li>
          </ul>
        </div>
        <div
          class="mc-upload-result mc-upload-result--warning"
          v-else-if="totalFailed > 0 && totalSuccess > 0"
        >
          <figure>
            <img src="@/assets/images/warning-icon.png" alt />
          </figure>
          <h4 class="mc-upload-result__label">
            {{ $t('license.object.uploadData') }} {{ docType }}
            {{ $t('license.object.partialSuccess') }}
          </h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('license.object.totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('license.object.dataSuccess') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('license.object.dataFailed') }}
            </li>
          </ul>
          <McButton
            variant="secondary"
            icon="icon-outline_download"
            :text="$t('license.object.downloadFail')"
            @click="toDownload"
          />
        </div>
        <div class="mc-upload-result mc-upload-result--error" v-else-if="totalSuccess === 0">
          <figure>
            <img :src="illustrationPathFailed" alt />
          </figure>
          <h4 class="mc-upload-result__label">
            {{ $t('license.object.uploadData') }} {{ docType }} {{ $t('global.failed') }}
          </h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('license.object.totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('license.object.dataSuccess') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('license.object.dataFailed') }}
            </li>
          </ul>
          <McButton
            variant="secondary"
            icon="icon-outline_download"
            :text="$t('license.object.downloadFail')"
            @click="toDownload"
          />
        </div>
      </div>
    </div>
  </div>
</template>
